var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-1"},[_c('figure',{staticClass:"m-1 image is-48x48 is-flex is-align-items-center is-justify-content-center",attrs:{"id":"clientFigure"}},[_c('img',{staticClass:"is-rounded",attrs:{"id":"clientProfilePicture","src":_vm.getPicture(_vm.client),"alt":"Klientenbild"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }